import { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="min-h-screen pt-32 pb-20 px-6 relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-amber-950/5 to-transparent pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className={`space-y-8 transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="inline-block px-4 py-2 bg-amber-500/10 border border-amber-500/20 rounded-full">
              <span className="text-xs uppercase tracking-[0.2em] text-amber-400 font-medium">
                Specialist in Gents Tailoring
              </span>
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold leading-tight tracking-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Modern Tailored Suits for{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">
                Weddings, Work
              </span>{' '}
              and Every Sharp Moment
            </h1>

            <p className="text-lg text-gray-400 leading-relaxed">
              Rinard Tailors creates premium gents suits, coats, shirts, trousers, ties and shoes with perfect fit. 
              Experience the art of bespoke tailoring where every stitch tells a story of craftsmanship and elegance.
            </p>

            {/* Feature chips */}
            <div className="flex flex-wrap gap-3">
              {['Made-to-measure', 'Wedding packages', 'Fast alterations'].map((feature) => (
                <div
                  key={feature}
                  className="px-5 py-2.5 bg-gray-900/50 border border-gray-800 rounded-full text-sm text-gray-300 hover:border-amber-500/50 hover:text-amber-400 transition-all cursor-default"
                >
                  {feature}
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 pt-4">
              <a
                href="tel:+94771107594"
                className="px-8 py-4 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black font-semibold rounded-full transition-all shadow-xl shadow-amber-500/30 hover:shadow-amber-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Book Appointment
              </a>
              <a
                href="https://wa.me/94771107594"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-gray-900/50 border border-gray-700 hover:border-amber-500 text-white font-semibold rounded-full transition-all hover:bg-gray-900 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp Us
              </a>
            </div>
          </div>

          {/* Right Content - Featured Suit Card */}
          <div className={`transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="relative group">
              {/* Glow effect */}
              <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-amber-600 rounded-3xl blur-2xl opacity-20 group-hover:opacity-30 transition-opacity"></div>
              
              {/* Card */}
              <div className="relative bg-gradient-to-br from-gray-900 to-gray-950 rounded-3xl overflow-hidden border border-gray-800 shadow-2xl">
                <div className="aspect-[3/4] relative overflow-hidden">
                  <img
                    src="https://public.readdy.ai/ai/img_res/e6d8f0c9ce5e74af3c8acba60fe5f0e0.jpg"
                    alt="Featured Navy 3-piece Suit"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-transparent to-transparent"></div>
                </div>
                
                {/* Card info */}
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <div className="inline-block px-3 py-1 bg-amber-500/20 backdrop-blur-sm border border-amber-500/30 rounded-full mb-3">
                    <span className="text-xs uppercase tracking-wider text-amber-400">Featured Look</span>
                  </div>
                  <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    Navy 3-Piece Suit
                  </h3>
                  <p className="text-gray-400 text-sm">
                    Classic elegance with brown leather shoes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
